import { Component, inject, PLATFORM_ID, signal, AfterViewInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
// @ts-ignore
import * as CookieConsent from 'vanilla-cookieconsent';
import { initializeFirebaseAppCheck } from './app/firebase/firebase-app-check';
import { environment } from '../environments/environment';
import { AppVersionReloadService } from './core/app-version/app-version-reload.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App implements AfterViewInit {
 
  
  protected readonly title = signal('Căsuța Jocului');
  private readonly platformId = inject(PLATFORM_ID);
  private readonly router = inject(Router);
  private readonly appCheckPathPrefixes = environment.appCheck?.enabledPathPrefixes ?? [];
  private readonly appVersionReload = inject(AppVersionReloadService);

  ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.appVersionReload.init();
    this.initializeAppCheckForPath(window.location.pathname);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.initializeAppCheckForPath(event.url);
      }
    });

    if (this.isKioskRoute()) {
      return;
    }

    CookieConsent.run({
      guiOptions: {
        consentModal: { layout: 'box', position: 'bottom right', flipButtons: false },
        preferencesModal: { layout: 'box' }
      },
      categories: {
        necessary: { readOnly: true },
        analytics: {},
        marketing: {}
      },
      language: {
        default: 'ro',
        translations: {
          ro: {
            consentModal: {
              title: 'Folosim cookie-uri',
              description:
                'Utilizăm cookie-uri pentru funcționare, analiză și personalizare. ' +
                'Poți alege ce accepți. Pentru detalii, vezi <a href="/docs/cookie" class="cc-link">Politica de Cookies</a>.',
              acceptAllBtn: 'Accept toate',
              acceptNecessaryBtn: 'Doar necesare',
              showPreferencesBtn: 'Preferințe'
            },
            preferencesModal: {
              title: 'Preferințe cookie',
              acceptAllBtn: 'Accept toate',
              acceptNecessaryBtn: 'Doar necesare',
              savePreferencesBtn: 'Salvează',
              sections: [
                {
                  title: 'Cookie-uri necesare',
                  description: 'Esențiale pentru funcționarea site-ului.',
                  linkedCategory: 'necessary'
                },
                {
                  title: 'Analitice',
                  description: 'Ne ajută să înțelegem cum este folosit site-ul.',
                  linkedCategory: 'analytics'
                },
                {
                  title: 'Marketing',
                  description: 'Folosite pentru personalizarea reclamelor.',
                  linkedCategory: 'marketing'
                }
              ]
            }
          }
        }
      },
      onConsent: ({ cookie }) => {
        const granted: string[] = cookie?.categories ?? [];
        if (granted.includes('analytics')) {
          // init GA aici
        }
      }
    });
  }

  private isKioskRoute(): boolean {
    const normalizedPath = window.location.pathname.replace(/\/+$/, '') || '/';
    return normalizedPath === '/display' || normalizedPath === '/internal-display';
  }

  private initializeAppCheckForPath(pathOrUrl: string): void {
    if (!this.shouldEnableAppCheck(pathOrUrl)) {
      return;
    }

    initializeFirebaseAppCheck();
  }

  private shouldEnableAppCheck(pathOrUrl: string): boolean {
    const path = pathOrUrl.split('?')[0]?.split('#')[0] ?? '/';
    const normalizedPath = path.replace(/\/+$/, '') || '/';

    return this.appCheckPathPrefixes.some((prefix) =>
      normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`)
    );
  }

  /** apelabil din footer */
  openCookiePreferences() {
    if (isPlatformBrowser(this.platformId)) {
      (CookieConsent as any)?.showPreferences?.();
    }
  }
}
